import { useState } from "react";
import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import './reassignModal.css';
import ActionInput from "../../../components/common/actioninput/ActionInputField";
import './FinalLTUpdateModal.css';

export const FinalLTUpdateModal = ({ openFinalLTUpdateModal, closeFinalLTUpdateModal, onClickSubmitButton }) => {

    //Modal content props below

    const [finalLTValue, setFinalLTValue] = useState();
    const [clickApply, setClickApply] = useState(false);
    const onChangeFinalLTValue = (e) => {
        const isValidNumber = /^[0-9]*$/.test(e.target.value);

        if (isValidNumber) {
            setFinalLTValue(e.target.value)
        }
    }
    const onClickFinalLTUpdateApplyButton = (e) => {
        setClickApply(true);
    }
    const onCloseLTModal = () => {
        setClickApply(false);
        setFinalLTValue("");
        closeFinalLTUpdateModal();
    }
    const onClickBack = () => {
        setClickApply(false);
    }
    const onClickFinalLTUpdateSubmitButton = () => {
        onClickSubmitButton(finalLTValue);
        onCloseLTModal()
    }

    return (
        <>
            <Modal
                className="finalLTUpdateModal_cls"
                open={openFinalLTUpdateModal}
                handleClose={onCloseLTModal}
                title="Recommended LT to be Updated in S/4"
                action={
                    <FinalLTUpdatedInS4Footer
                        onClickFinalLTUpdateApplyButton={onClickFinalLTUpdateApplyButton}
                        onClickFinalLTUpdateSubmitButton={onClickFinalLTUpdateSubmitButton}
                        onCloseLTModal={onCloseLTModal}
                        finalLTValue={finalLTValue}
                        clickApply={clickApply}
                        onClickBack={onClickBack}
                    />
                }
                content={
                    <FinalLTUpdatedInS4Content
                        finalLTValue={finalLTValue}
                        onChangeFinalLTValue={onChangeFinalLTValue}
                        clickApply={clickApply}
                    />
                }
                maxWidth="500px"
            />
        </>
    )
}

const FinalLTUpdatedInS4Footer = ({ onClickBack, onClickFinalLTUpdateApplyButton, finalLTValue, clickApply, onClickFinalLTUpdateSubmitButton }) => {

    return (
        clickApply === true ?
            <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                <ButtonComponent
                    label="Back"
                    type="primary"
                    maxWidth="80px"
                    onClick={onClickBack}
                />
                <ButtonComponent
                    label="OK"
                    type="secondary"
                    maxWidth="80px"
                    onClick={onClickFinalLTUpdateSubmitButton}
                />
            </div>
            : <div className='finalLTupdatedfooter-btn-wrapper'>
                <ButtonComponent
                    label="Apply"
                    type="secondary"
                    maxWidth="80px"
                    onClick={onClickFinalLTUpdateApplyButton}
                    disabled={finalLTValue?.length <= 0 || finalLTValue === undefined}
                />
            </div>
    );
};
const FinalLTUpdatedInS4Content = ({ onChangeFinalLTValue, finalLTValue, clickApply }) => {
    return (
        clickApply === true ?
            <div>
                <p>Warning - you are updating the lead time for all selected line item</p>
            </div> :
            <div className='finalLTupdatedContent-btn-wrapper'>
                <ActionInput
                    bgColor="black"
                    color="white"
                    value={finalLTValue}
                    onChange={onChangeFinalLTValue}
                    maxWidth="100px"
                />
                <span id="helperText">Note: Please enter only numbers</span>
            </div>
    );
};